
import { useState, useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputDecimal(props)
{
 

    
    const [val, setVal] = useState(props.value);    
    const [maxDec, setMaxDec] = useState(props.maxDec);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);


    const validate = (vx) => {
        return false;
      };


    const formatDec = (dec) => {

       // console.log("formatDEC ", dec ); 

        if(dec == null || dec == undefined)
            {
                return '';
            }

        dec = dec + "";
              
        let iMinus = false;
        let str = dec.split('');

        for(var cc=0; cc<str.length;cc++)
        {
            if(str[cc] == '-') iMinus = true;
        }
       

        
        var num = dec.replace(",",".");
        num = num.replace(" ","");
        num = num.replace(/[^0-9.]/g, ''); 

        if(iMinus)
            {
                num = "-" + num;
            } 

        var digits = (""+num).split("");

      

        if(digits.length == 0) return "0";

        var findDot = -1;
        var merge = "";

     
        for(var k=0; k<digits.length; k++)
        {
            if(digits[k] == '0' && k == 0) continue;

            if(digits[k] == '.' || digits[k] == ',') 
            {
                if(findDot == -1)
                {
                    merge += ".";
                }

                findDot = k;
                continue;
            }

            if(findDot >-1)
            {
                var decS = k - findDot;
                if(decS > maxDec) continue;

                
            }
            

            merge += "" + digits[k];
            
        }
        



        return merge;
    }

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

       
         v = formatDec(v);                  
         setVal(v);


        var correct = true;

 
                 
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        


        
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" )
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent"  )
    {
        imgx = <img className="input_status" src={input_check} />
    }


    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

     

 
    var tmp = formatDec(val);

   // console.log("formatDEC", val, tmp);

        tmp = tmp.replace(".",",");
        
        if(tmp.length == 0) tmp = "0";

        if(tmp.length > 0)
        {
           var firstC = Array.from(tmp)[0];
           if(firstC == ',') tmp = "0" + tmp;
        }
    

        var err = "";
        if(props.err != undefined  &&  props.err != null ) 
        {       
            if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
        }    
        
        
        var cnX = cn;
        if(val != null && val != undefined &&  val.length < 1 && cnX == 'corrent')
            {
                cnX = '';
            }


            var defClass = " w150 ";
            if(props.className != null && props.className != undefined) defClass = props.className;


    return <fieldset>        
        <input type="text"  value={tmp} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={ "goright " +  defClass + " " + cnX} />        
        {imgx}
        <br/>
        <span className="form_err">{err + " "} &nbsp; </span>
    </fieldset>
}


export default InputDecimal;